export default {"src":"/_next/static/media/distance.4061715b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};